import ErrorBoundary from './ErrorBoundary';
import CustomErrorBoundary from './CustomErrorBoundary';

export { CustomErrorBoundary };
export default ErrorBoundary;
